import { AxiosResponse } from 'axios';
import requestClient from '../components/Utility/RequestClient';

export const dlpService = {
    encryptFile: async (formData: { file: string }): Promise<AxiosResponse> => {
        return requestClient.post(`/dlp/encryptfile`, formData);
    },
};
